import { gql } from "@apollo/client";

export const GET_ACTIVE_PACKAGE_DISCOUNTS = gql`
  query getActivePackageDiscounts {
    getActivePackageDiscounts {
      id
      name
      description
      rules {
        when {
          field
          operator
          value
          values
        }
        discount {
          type
          value
          label
        }
      }
    }
  }
`;
